import CourseCard from "./CourseCard";
import { Card, CardContent } from "@/components/ui/card";

export default function CourseGrid({ courses, onCourseSelect, loading = false }) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {[1, 2, 3, 4].map((idx) => (
          <div key={idx} className="h-96 rounded-lg bg-muted animate-pulse" />
        ))}
      </div>
    );
  }

  if (!courses || courses.length === 0) {
    return (
      <Card className="py-14 text-center">
        <CardContent className="space-y-2">
          <p className="text-base font-semibold">No courses available</p>
          <p className="text-sm text-muted-foreground">Check back soon for new courses.</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {courses.map((course) => (
        <CourseCard
          key={course.id}
          course={course}
          onSelect={() => onCourseSelect(course)}
        />
      ))}
    </div>
  );
}
